import { Spin } from "antd";
import OrderInfo from "../../../../../containers/order_info/order_info";
import { useAllClientOrders } from "../../../../../hooks/order_list_views/useAllClientOrders.hook";

export default function AllOrdersClient(){
    
    const hook = useAllClientOrders()
    
    if(hook.loading) return(<Spin />);
    else if(hook.data == null) return <>Null</>
    else return(
        <OrderInfo
            hook={hook}
            type="all"
        />
    );
}